import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['locationInput', 'zoneInput'];

  connect() {
    if (!this.locationInputTarget.checked) {
      this.show(this.zoneInputTarget.parentElement, false);
    }
  }

  show(target, show = true) {
    if (show) {
      target.classList.remove('hide');
    } else {
      target.classList.add('hide');
    }
  }

  toggleZoneInputVisibility (e) {
    if (!this.locationInputTarget.checked) {
      this.zoneInputTarget.checked = false
      this.show(this.zoneInputTarget.parentElement, false);
    } else {
      this.show(this.zoneInputTarget.parentElement, true);
    }
  }
}
